import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Phone, Mail, Clock, ClipboardCheck, Handshake } from "lucide-react";
import { company } from "@/mocks/home";

const nextSteps = [
  {
    icon: ClipboardCheck,
    title: "Análise do pedido",
    text: "A nossa equipa recebe e analisa a informação que partilhou sobre o seu condomínio.",
  },
  {
    icon: Clock,
    title: "Contacto em 1 dia útil",
    text: "Entramos em contacto consigo no prazo de um dia útil para combinar os detalhes da reunião.",
  },
  {
    icon: Handshake,
    title: "Reunião sem compromisso",
    text: "Apresentamos uma proposta à medida e respondemos a todas as suas dúvidas.",
  },
];

export default function Thanks() {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-accent-500/10 blur-3xl"
        aria-hidden="true"
      />

      <header className="relative z-10 w-full">
        <div className="mx-auto flex h-16 w-full max-w-container items-center px-4 md:h-20 md:px-6 lg:px-10">
          <Link to="/" className="flex cursor-pointer items-center gap-2.5" aria-label="Porta31 Condomínios - início">
            <img
              src={company.logo}
              alt="Logótipo da Porta31 Condomínios"
              title="Porta31 Condomínios"
              className="h-14 w-auto object-contain md:h-16"
            />
            <span className="font-heading text-lg font-bold leading-tight tracking-tight text-foreground-950 md:text-xl">
              {company.name}
            </span>
          </Link>
        </div>
      </header>

      <main className="relative z-10 flex w-full flex-1 items-center justify-center px-4 py-10 md:px-6 md:py-16">
        <div className="w-full max-w-2xl">
          <div className="animate-fade-up rounded-lg border border-background-200 bg-background-50 p-7 text-center md:p-10">
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary-100">
              <CheckCircle2 className="h-10 w-10 text-primary-700" />
            </div>

            <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              Pedido Recebido
            </span>

            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              Obrigado pelo seu contacto!
            </h1>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              O seu pedido de reunião foi recebido com sucesso pela <strong>{company.name}</strong>. Entraremos em
              contacto consigo o mais breve possível para combinar todos os detalhes.
            </p>

            <div className="mt-9 grid gap-4 text-left sm:grid-cols-3">
              {nextSteps.map((step) => (
                <div
                  key={step.title}
                  className="rounded-lg border border-background-200 bg-background-100/60 p-4"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/10">
                    <step.icon className="h-5 w-5 text-primary-600" />
                  </div>
                  <p className="mt-3 font-heading text-sm font-semibold text-foreground-950">{step.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              ))}
            </div>

            <Link
              to="/"
              className="mt-9 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-all duration-300 hover:scale-[1.01] hover:bg-primary-600 dark:text-foreground-950 sm:w-auto"
            >
              <ArrowLeft className="h-4 w-4" />
              Voltar à Página Inicial
            </Link>

            <div className="mt-8 border-t border-background-200 pt-6">
              <p className="text-xs font-medium uppercase tracking-[0.14em] text-foreground-500">
                Precisa de falar connosco agora?
              </p>
              <div className="mt-4 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href={company.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Contactar a Porta31 por WhatsApp"
                  className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-300 hover:border-primary-400 hover:text-primary-700 sm:w-auto"
                >
                  <Phone className="h-4 w-4" />
                  {company.phoneDisplay}
                </a>
                <a
                  href={`mailto:${company.email}`}
                  aria-label="Enviar email para a Porta31 Condomínios"
                  className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-300 hover:border-primary-400 hover:text-primary-700 sm:w-auto"
                >
                  <Mail className="h-4 w-4" />
                  Enviar email
                </a>
              </div>
            </div>
          </div>

          <p className="mt-6 text-center text-xs text-foreground-500">
            © {new Date().getFullYear()} {company.name}. Gestão de condomínios em Vila Nova de Famalicão.
          </p>
        </div>
      </main>
    </div>
  );
}